import React from "react";
import CountWasteWoodForm from "./CountWasteWoodForm";
import { Toast } from "../../utils/Toast";
import { GET, POST, PUT } from "../../utils/HttpClient";
import * as _ from "lodash";
import { useTranslation } from "react-i18next";
import { URL_POST_BAKING } from "../../constance/urls";
import ErrorMessage from "../common/ErrorMessage";
import { Modal, Button, Form } from "antd";
import { EditOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { BLUE_COLOR, GREEN } from "../../constance/color";
import ColorButton from "../common/ColorButton";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../constance/strings";
import useCountWasteWoodValidate from "./useCountWasteWoodValidate";


export default function WasteWoodCountModal(props) {
  const {
    transaction,
    open,
    onClose,
    target
  } = props;

  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target == 'add';
  const countWasteWoodValdiate = useCountWasteWoodValidate()

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT_WOOD_SIZE_AMOUNT_MAP}${target}/`)
      form.setFieldsValue(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const validate = await form.validateFields();
      const date = dayjs(_.get(transaction, 'post_baking_group_date', '')).format(DATE_FORMAT)

      const message = await countWasteWoodValdiate.doValidate({
        date: date,
        ovens: _.get(transaction, 'ovens', []).join(','),
        grade: values.grade, wood_code_dimension: values.wood_code_dimension,
        amount: values.amount, exclude_target: isCreate ? null : target,
      })

      if (isCreate) {
        await POST(URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT_WOOD_SIZE_AMOUNT_MAP, values)

      } else {
        await PUT(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_COUNT_WOOD_SIZE_AMOUNT_MAP}${target}/`, values)
      }
      if (message) {
        Toast.warning(`${t('save')} ${t('success')} : ${message}`)
      } else {
        Toast.success(`${t('save')} ${t('success')}`)
      }

      onClose();
    } catch (error) {
      setErrorMessages(_.get(error, 'errorMessages', error))
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (open) {
      form.resetFields();
      if (!isCreate) {
        fetchData()
      } else {
        form.setFieldValue('transaction', _.get(transaction, 'id', null))
      }
    }
  }, [open])

  return (
    <Modal
      open={open} onCancel={onClose}
      title={isCreate ? t('add') : `${t('edit')} ${t('post_baking_waste_wood_count.detail')}`}
      footer={[
        <Button
          color="default"
          variant="filled"
          icon={<CloseOutlined />}
          loading={loading}
          onClick={onClose} >{t('cancel')}</Button>,
        <ColorButton
          type="primary"
          override={isCreate ? GREEN : BLUE_COLOR}
          icon={isCreate ? <PlusOutlined /> : <EditOutlined />}
          loading={loading}
          onClick={() => handleSubmit(form.getFieldsValue())}  >{isCreate ? t('add') : t('edit')}</ColorButton>,

      ]}>
      <ErrorMessage message={errorMessages} />
      <CountWasteWoodForm form={form} handleSubmit={form.submit} />
    </Modal>

  )
}
